<div class="pass-wizard-page">
    <div class="pass-wizard-wrapper">

        <h1 class="title-wizard">Hazte Abonado del Club Balonmano Ciudad de Logroño</h1>
        <p class="subtitle-wizard">Elige tu categoría y tu butaca, completa tus datos y finaliza con el pago de tu abono.</p>

        <div class="card-wizard">

            <!-- Sin categorías ni temporada no hay alta posible: hasta que carguen
                 (o si fallan) no se pinta el formulario. -->
            <div class="context-loading" *ngIf="loadingContext">
                <i class="fal fa-spinner fa-spin"></i>
                <p>Cargando el alta de abonados...</p>
            </div>

            <div *ngIf="!loadingContext && contextErrorMsg" class="info-error">
                <i class="fa-light fa-circle-exclamation"></i>
                <p class="error-msg">{{ contextErrorMsg }}</p>
            </div>

            <ng-container *ngIf="!loadingContext && context">
                <!-- Ancla de los avisos: el botón de alta está al final de una
                     tarjeta larga, así que al fallar hay que traer la vista aquí
                     (ver scrollToAlerts) o parece que no ha pasado nada. -->
                <div id="wizard-alerts">
                    <div *ngIf="showErrorMsg" class="info-error">
                        <i class="fa-light fa-circle-exclamation"></i>
                        <p class="error-msg">Falta completar: {{ missingFields.join(', ') }}</p>
                    </div>
                    <div *ngIf="showGenericError" class="info-error">
                        <i class="fa-light fa-circle-exclamation"></i>
                        <p class="error-msg">Ha ocurrido un error, vuelve a intentarlo.</p>
                    </div>
                    <div *ngIf="signupErrorMsg" class="info-error" [class.with-action]="userHasOtherPass">
                        <i class="fa-light fa-circle-exclamation"></i>
                        <div class="notice-body">
                            <p class="error-msg">{{ signupErrorMsg }}</p>
                            <!-- Solo cuando la cuenta ya tiene abono: reintentar no
                                 va a funcionar nunca, lo único accionable es ir a verlo -->
                            <button *ngIf="userHasOtherPass" type="button" class="btn-wizard-outline notice-btn" (click)="goToMyPasses()">Ir a mis abonos</button>
                        </div>
                    </div>
                </div>

                <form [formGroup]="signupForm">
                    <div class="summary-section">
                        <div class="summary-title"><i class="fa-solid fa-circle-check"></i> Datos del abono</div>

                        <div class="summary-grid">
                            <!-- La temporada la fija la propia URL de alta y el recinto lo
                                 resuelve el servidor desde ella: aquí solo se muestran. -->
                            <div class="summary-item">
                                <span class="summary-label">Temporada</span>
                                <p class="summary-value">{{ context.season.name }}</p>
                            </div>
                            <div class="summary-item" *ngIf="context.space_name">
                                <span class="summary-label">Recinto</span>
                                <p class="summary-value">{{ context.space_name }}</p>
                            </div>
                        </div>

                        <div class="field-block">
                            <label class="label-input">Categoría de abonado</label>
                            <div class="form-input-container" [class.invalid]="signupForm.get('idCategory')?.invalid && signupForm.get('idCategory')?.touched">
                                <select class="w-100" formControlName="idCategory">
                                    <option [ngValue]="null" disabled>Elige tu categoría</option>
                                    <option *ngFor="let category of context.categories" [ngValue]="category.id">{{ category.name }}</option>
                                </select>
                            </div>
                            <span class="field-hint">El importe de tu abono depende de tu categoría y del nivel de la butaca que elijas.</span>
                            <span class="field-error" *ngIf="signupForm.get('idCategory')?.invalid && signupForm.get('idCategory')?.touched">Elige tu categoría de abonado</span>
                        </div>

                        <!-- Butaca: obligatoria y solo elegible en el mapa. Sin ella el
                             checkout no podría calcular el precio del abono. -->
                        <div class="seat-info seat-info--new" *ngIf="selectedSeatDisplay">
                            <div class="seat-info-icon"><i class="fa-light fa-chair"></i></div>
                            <div class="seat-info-body">
                                <span class="seat-info-label">Tu butaca</span>
                                <p class="seat-info-level">{{ selectedSeatDisplay }}</p>
                            </div>
                            <button type="button" class="seat-info-undo" (click)="clearSeat()">
                                <i class="fa-light fa-xmark"></i> Quitar
                            </button>
                        </div>

                        <div class="seat-empty" *ngIf="!selectedSeatDisplay">
                            <i class="fa-light fa-chair"></i>
                            <p>Todavía no has elegido butaca. Elígela en el mapa del recinto para continuar.</p>
                        </div>

                        <button type="button" class="btn-change-seat" (click)="openSeatMap()" [disabled]="loadingSeatMap">
                            <i class="fa-light" [ngClass]="loadingSeatMap ? 'fa-spinner-third fa-spin' : 'fa-map-location-dot'"></i>
                            {{ selectedSeatDisplay ? 'Elegir otra butaca' : 'Elegir butaca en el mapa' }}
                        </button>
                        <!-- Mismo aviso que los de la cabecera del asistente: suelto y sin
                             color pasaba por texto de la página (no está dentro de un
                             .field-block, así que ni siquiera heredaba el rojo de .field-error). -->
                        <div class="info-error seat-error" *ngIf="seatErrorMsg">
                            <i class="fa-light fa-circle-exclamation"></i>
                            <p class="error-msg">{{ seatErrorMsg }}</p>
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="summary-title account-title">
                        <i class="fa-light" [ngClass]="isLoggedIn ? 'fa-circle-user' : 'fa-envelope'"></i>
                        {{ isLoggedIn ? 'Tu cuenta' : 'Tu cuenta de Citylok' }}
                    </div>

                    <div class="email-exists-prompt" *ngIf="isLoggedIn">
                        <p *ngIf="!sessionStartedHere">Tu abono se creará en tu cuenta: <strong>{{ currentUserEmail }}</strong></p>
                        <p *ngIf="sessionStartedHere"><i class="fa-solid fa-circle-check"></i> Sesión iniciada{{ googleSession ? ' con Google' : '' }} como <strong>{{ currentUserEmail }}</strong>. El abono se creará en esta cuenta.</p>
                    </div>

                    <!-- 0. Google: la alternativa al email + contraseña, disponible desde el
                         principio. Es la ÚNICA vía para quien creó su cuenta de Citylok con
                         Google (su contraseña es aleatoria y no la conoce), y a quien no
                         tiene cuenta se la crea ya activa. -->
                    <ng-container *ngIf="!isLoggedIn">
                        <div class="google-signin">
                            <!-- El botón real de Google, debajo: es el que se pulsa. El de
                                 arriba solo es la piel de Citylok (pointer-events: none). -->
                            <div class="google-btn-real">
                                <asl-google-signin-button type="standard" shape="rectangular" size="large" width="280"></asl-google-signin-button>
                            </div>
                            <div class="btn-google-sign">
                                <img src="/assets/img/google_icon.png" alt="Google">
                                <span>{{ loadingGoogle ? 'Iniciando sesión...' : 'Continuar con Google' }}</span>
                            </div>
                        </div>

                        <div class="google-divider">
                            <mat-divider></mat-divider>
                            <span>o continúa con tu email</span>
                            <mat-divider></mat-divider>
                        </div>
                    </ng-container>

                    <!-- 1. El email es lo primero que se pide: identifica la cuenta y decide
                         el resto del formulario (iniciar sesión o crear una cuenta nueva) -->
                    <div class="field-block" *ngIf="!isLoggedIn">
                        <label class="label-input">Email</label>
                        <div class="form-input-container" [class.invalid]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
                            <input type="email" class="w-100" placeholder="ejemplo@correo.com" formControlName="email">
                        </div>
                        <span class="field-error" *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">Introduce un email válido</span>
                    </div>

                    <!-- Repetido para descartar erratas: es la cuenta donde va a
                         quedar el abono y con la que tendrá que entrar después. -->
                    <div class="field-block" *ngIf="!isLoggedIn">
                        <label class="label-input">Repetir email</label>
                        <div class="form-input-container" [class.invalid]="emailConfirm.invalid && emailConfirm.touched">
                            <input type="email" class="w-100" placeholder="Repite tu email" formControlName="emailConfirm">
                        </div>
                        <span class="field-error" *ngIf="emailConfirm.invalid && emailConfirm.touched">
                            {{ emailConfirm.errors?.['mismatch'] ? 'Los emails no coinciden' : 'Repite tu email' }}
                        </span>
                    </div>

                    <!-- No se pide nada más hasta saber si ese email ya tiene cuenta -->
                    <div *ngIf="!isLoggedIn && !emailConfirmed" class="email-continue-row">
                        <button type="button" class="btn-wizard-outline" [class.disabled]="checkingEmail" (click)="!checkingEmail && checkEmailAndReveal()">
                            <i class="fal fa-spinner fa-spin" *ngIf="checkingEmail"></i>
                            {{ checkingEmail ? 'Comprobando...' : 'Continuar' }}
                        </button>
                    </div>

                    <!-- 2a. Cuenta ya existente: se inicia sesión con su contraseña aquí
                         mismo, tanto para prellenar sus datos como para que el alta pueda
                         autorizarse con el token. -->
                    <ng-container *ngIf="!isLoggedIn && emailConfirmed && showEmailExistsPrompt">
                        <div class="email-exists-prompt">
                            <p *ngIf="!existingAccountInactive">Ya existe una cuenta con este email. Inicia sesión para recuperar tus datos y continuar con tu alta. Si la creaste con Google, entra con Google.</p>
                            <p *ngIf="existingAccountInactive">Ya existe una cuenta con este email, pero está pendiente de verificar. Introduce tu contraseña y completa tus datos para continuar.</p>
                        </div>

                        <div class="field-block" id="existing-password-field">
                            <label class="label-input">Contraseña</label>
                            <div class="form-input-container" [class.invalid]="showExistingLoginError">
                                <input [type]="hideExistingPassword ? 'password' : 'text'" class="w-100" placeholder="Tu contraseña" formControlName="existingAccountPassword">
                                <i class="fa-regular icon-password" [ngClass]="hideExistingPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="hideExistingPassword = !hideExistingPassword"></i>
                            </div>
                            <span class="field-error" *ngIf="showExistingLoginError">Contraseña incorrecta, vuelve a intentarlo</span>
                        </div>

                        <div class="email-continue-row" *ngIf="!existingAccountInactive">
                            <button type="button" class="btn-wizard-outline" [class.disabled]="loadingExistingLogin" (click)="!loadingExistingLogin && loginExistingAccountAndPrefill()">
                                <i class="fal fa-spinner fa-spin" *ngIf="loadingExistingLogin"></i>
                                {{ loadingExistingLogin ? 'Iniciando sesión...' : 'Iniciar sesión' }}
                            </button>
                        </div>
                    </ng-container>

                    <!-- 2b. Email sin cuenta: crea la contraseña de su cuenta nueva -->
                    <div class="field-block" *ngIf="!isLoggedIn && emailConfirmed && !showEmailExistsPrompt">
                        <label class="label-input">Contraseña</label>
                        <div class="form-input-container" [class.invalid]="password.invalid && password.touched">
                            <input [type]="hidePassword ? 'password' : 'text'" class="w-100" placeholder="Crea una contraseña" formControlName="password">
                            <i class="fa-regular icon-password" [ngClass]="hidePassword ? 'fa-eye-slash' : 'fa-eye'" (click)="hidePassword = !hidePassword"></i>
                        </div>
                        <div class="validate-msg" *ngIf="password.invalid && (password.dirty || password.touched)">
                            <div><i class="fa-light" [ngClass]="password.errors?.['hasSmallCase'] ? 'fa-circle' : 'fa-circle-check'"></i> Debe contener minúsculas</div>
                            <div><i class="fa-light" [ngClass]="password.errors?.['hasCapitalCase'] ? 'fa-circle' : 'fa-circle-check'"></i> Debe contener mayúsculas</div>
                            <div><i class="fa-light" [ngClass]="password.errors?.['hasNumber'] ? 'fa-circle' : 'fa-circle-check'"></i> Debe contener números</div>
                            <div><i class="fa-light" [ngClass]="password.errors?.['minlength'] || password.errors?.['required'] ? 'fa-circle' : 'fa-circle-check'"></i> Al menos 8 caracteres</div>
                        </div>
                    </div>

                    <!-- Repetida por lo mismo que el email: con una errata aquí la
                         cuenta quedaría creada con una contraseña que no conoce. -->
                    <div class="field-block" *ngIf="!isLoggedIn && emailConfirmed && !showEmailExistsPrompt">
                        <label class="label-input">Repetir contraseña</label>
                        <div class="form-input-container" [class.invalid]="passwordConfirm.invalid && passwordConfirm.touched">
                            <input [type]="hidePasswordConfirm ? 'password' : 'text'" class="w-100" placeholder="Repite la contraseña" formControlName="passwordConfirm">
                            <i class="fa-regular icon-password" [ngClass]="hidePasswordConfirm ? 'fa-eye-slash' : 'fa-eye'" (click)="hidePasswordConfirm = !hidePasswordConfirm"></i>
                        </div>
                        <span class="field-error" *ngIf="passwordConfirm.invalid && passwordConfirm.touched">
                            {{ passwordConfirm.errors?.['mismatch'] ? 'Las contraseñas no coinciden' : 'Repite la contraseña' }}
                        </span>
                    </div>

                    <!-- 3. Datos personales: solo cuando ya se sabe la cuenta, para poder
                         llegar prellenados con lo que esta tuviera guardado -->
                    <ng-container *ngIf="showPersonalData">
                        <div class="field-block">
                            <label class="label-input">Nombre y apellidos</label>
                            <div class="form-input-container" [class.invalid]="signupForm.get('nombreApellidos')?.invalid && signupForm.get('nombreApellidos')?.touched">
                                <input type="text" class="w-100" placeholder="Nombre y apellidos del abonado" formControlName="nombreApellidos">
                            </div>
                            <span class="field-error" *ngIf="signupForm.get('nombreApellidos')?.invalid && signupForm.get('nombreApellidos')?.touched">Introduce el nombre completo del abonado</span>
                        </div>

                        <div class="field-block">
                            <label class="label-input">DNI/NIE</label>
                            <div class="form-input-container" [class.invalid]="signupForm.get('nif')?.invalid && signupForm.get('nif')?.touched">
                                <input type="text" class="w-100" placeholder="12345678A" formControlName="nif">
                            </div>
                            <span class="field-error" *ngIf="signupForm.get('nif')?.invalid && signupForm.get('nif')?.touched">Introduce un DNI/NIE válido</span>
                        </div>

                        <div class="field-block">
                            <label class="label-input">Fecha de nacimiento</label>
                            <div class="form-input-container" [class.invalid]="signupForm.get('fechaNacimiento')?.invalid && signupForm.get('fechaNacimiento')?.touched">
                                <app-date-field class="w-100" appearance="plain" formControlName="fechaNacimiento" [max]="maxBirthDate"></app-date-field>
                            </div>
                            <span class="field-hint">La necesitamos para asignarte la categoría de abono que te corresponda en las próximas temporadas.</span>
                            <span class="field-error" *ngIf="signupForm.get('fechaNacimiento')?.invalid && signupForm.get('fechaNacimiento')?.touched">Introduce una fecha de nacimiento válida</span>
                        </div>

                        <div class="checkbox-row" [class.invalid]="signupForm.get('condaccept')?.invalid && showErrorMsg">
                            <mat-checkbox formControlName="condaccept" color="primary"></mat-checkbox>
                            <!-- En pestaña nueva: si se navega en la misma se pierde el wizard. -->
                            <p>Acepto darme de alta como abonado y los <a [routerLink]="['/terms-conditions']" target="_blank" rel="noopener">términos de uso</a>.</p>
                        </div>
                    </ng-container>

                    <div class="privacy-note">
                        <i class="fa-light fa-shield-check"></i>
                        <p>Sus datos se tratarán de forma segura. Citylok cumple con la normativa RGPD para la protección de su identidad digital. Consulta nuestra <a [routerLink]="['/privacy']">política de privacidad</a>.</p>
                    </div>

                    <div class="wizard-actions">
                        <!-- Un solo botón: `finishSignup` decide qué autoriza el alta (la
                             sesión, la contraseña de la cuenta o la contraseña nueva). -->
                        <button type="button" class="btn-wizard" *ngIf="!userHasOtherPass && showPersonalData" [class.disabled]="loadingSignup" (click)="!loadingSignup && finishSignup()">
                            <i class="fal fa-spinner fa-spin" *ngIf="loadingSignup"></i>
                            {{ loadingSignup ? 'Creando tu abono...' : 'Continuar al pago' }}
                        </button>
                    </div>
                </form>
            </ng-container>
        </div>

        <p class="support-note">¿Tienes alguna duda? <a [routerLink]="['/contact']">Contacta con soporte</a></p>
    </div>
</div>
